import { render } from "./ResultDialog.vue?vue&type=template&id=67916490"
import script from "./ResultDialog.vue?vue&type=script&lang=js"
export * from "./ResultDialog.vue?vue&type=script&lang=js"

import "./ResultDialog.vue?vue&type=style&index=0&id=67916490&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__